import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "hidedynamicsdate",
  pure: false,
  standalone: true,
})
export class HidedynamicsdatePipe implements PipeTransform {
  transform(value: string | null | undefined): boolean {
    if (!value) return false;
    return !String(value).includes("1900-01-01");
  }
}
